import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import AuthModal from "@/components/AuthModal";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import PaymentStatus from "@/pages/PaymentStatus";
import Wishlist from "@/pages/Wishlist";
import Orders from "@/pages/Orders";
import BullFamily from "@/pages/BullFamily";
import Admin from "@/pages/Admin";
import ReturnsPolicy from "@/pages/ReturnsPolicy";
import SizeGuide from "@/pages/SizeGuide";
import TryOn from "@/pages/TryOn";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <AppProvider>
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/payment/success" element={<PaymentStatus type="success" />} />
              <Route path="/payment/cancel" element={<PaymentStatus type="cancel" />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/wallet" element={<BullFamily />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/returns" element={<ReturnsPolicy />} />
              <Route path="/size-guide" element={<SizeGuide />} />
              <Route path="/try-on" element={<TryOn />} />
            </Routes>
          </main>
          <Footer />
          <CartDrawer />
          <AuthModal />
          <Toaster position="top-center" richColors />
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
